import { create } from "zustand";
import { api } from "../api/client";

interface LikesStore {
  ids: Set<number>;
  loaded: boolean;
  load: () => Promise<void>;
  toggle: (productId: number) => Promise<void>;
}

export const useLikesStore = create<LikesStore>((set, get) => ({
  ids: new Set(),
  loaded: false,

  load: async () => {
    if (get().loaded) return;
    const ids = await api<number[]>("/me/liked-ids");
    set({ ids: new Set(ids), loaded: true });
  },

  toggle: async (productId) => {
    const prev = new Set(get().ids);
    const wasLiked = prev.has(productId);

    // Оптимистичное обновление
    const next = new Set(prev);
    if (wasLiked) next.delete(productId);
    else next.add(productId);
    set({ ids: next });

    try {
      const { liked } = await api<{ liked: boolean }>(`/products/${productId}/like`, {
        method: "POST",
      });
      // Синхронизируем с ответом сервера
      set((s) => {
        const synced = new Set(s.ids);
        if (liked) synced.add(productId);
        else synced.delete(productId);
        return { ids: synced };
      });
    } catch {
      // Откатываем при ошибке
      set({ ids: prev });
    }
  },
}));
